import { Case, DocumentStatus, Source } from 'briefpoint-client';
import { Dispatch, SetStateAction, useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { DocumentClient } from 'services/DocumentService';
import AddToCalendarModal from './AddToCalendarModal';

export default function DocumentActionsMenu({
  document,
  _case,
  archiveDocument,
  editDueDate,
  setShowSetCase,
  downloadForm,
  downloadRequest
}: {
  document: DocumentClient;
  _case?: Case;
  archiveDocument: (document: DocumentClient) => Promise<void>;
  editDueDate: Dispatch<SetStateAction<DocumentClient | undefined>>;
  setShowSetCase?: Dispatch<SetStateAction<DocumentClient | undefined>>;
  downloadForm: (document: DocumentClient, formId: string, formTypeName: string) => Promise<void>;
  downloadRequest: (document: DocumentClient) => Promise<void>;
}) {
  const [showAddToCalendar, setShowAddToCalendar] = useState(false);

  const dueDate = document?.info?.dueDateOverridden || document?.info?.dueDate;
  const verficationFormId = '790e8cdb-e584-47f1-a010-8d4aa36be35e';
  const isExternal = document.source !== Source.InternalGenerated;

  return (
    <>
      <NavDropdown
        title={<ThreeDotsVertical />}
        id="collapsible-nav-dropdown"
        className="doc-list-actions-dropdown"
      >
        <>
          {isExternal && (document.status === DocumentStatus.Complete ||
            document.status === DocumentStatus.InfoConfirmed) && (
              <NavDropdown.Item onClick={() => editDueDate(document)}>
                {`${dueDate ? 'Edit' : 'Set'} Due Date`}
              </NavDropdown.Item>
            )}
          {isExternal && dueDate && (
            <NavDropdown.Item onClick={() => setShowAddToCalendar(true)}>Add to Calendar</NavDropdown.Item>
          )}
          {isExternal && setShowSetCase && !document.caseId && (
            <NavDropdown.Item onClick={() => setShowSetCase(document)}>Set Case & Client</NavDropdown.Item>
          )}
          {!isExternal && (
            <NavDropdown.Item onClick={() => downloadRequest(document)}>Download</NavDropdown.Item>
          )}
        </>
        {isExternal && !!document.caseId && (document.status ?? 0) > DocumentStatus.Processed && <NavDropdown.Item onClick={() => downloadForm(document, verficationFormId, 'Verfication')}>Download Verification</NavDropdown.Item>}
        <NavDropdown.Item onClick={() => archiveDocument(document)}>Archive</NavDropdown.Item>
      </NavDropdown>

      {(document.info?.dueDateOverridden || document.info?.dueDate) && (
        <AddToCalendarModal
          isShow={showAddToCalendar}
          doc={document}
          _case={_case}
          onClose={() => setShowAddToCalendar(false)}
        />
      )}
    </>
  );
}
